import { render, staticRenderFns } from "./TopicoExperienciaImersiva.vue?vue&type=template&id=49a2ae20&"
import script from "./TopicoExperienciaImersiva.vue?vue&type=script&lang=js&"
export * from "./TopicoExperienciaImersiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports